<template>
    <div>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-btn slot="activator" class="red white--text">Upload your resume</v-btn>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click.native="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Candidate Information</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form validate class="ma-5 align-center justify-center">
                        <v-text-field style="width: 250px"
                                      v-model="firstName"
                                      :counter="10"
                                      label="First Name"
                                      required></v-text-field>
                        <v-text-field
                                style="width: 250px"
                                v-model="lastName"
                                :counter="10"
                                label="Last Name"
                                required></v-text-field>
                        <v-text-field
                                style="width: 250px"
                                v-model="email"
                                :rules="emailRules"
                                label="E-mail"
                                required></v-text-field>

                        <label>Resume
                            <input type="file" ref="resumeFile" v-on:change="uploadResume()"/>
                        </label>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click.prevent="saveCandidate">submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-alert
                v-model="alert"
                dismissible
                type="success"
                >
            <p>
                {{ this.firstName }} {{ this.lastName}} your resume has been received.
            </p>
        </v-alert>
    </div>
</template>

<script>
    import {storage} from "../../../main";

    export default {
        name: "NewCandidate",
        data: () => ({
            alert: false,
            dialog: false,
            firstName: null,
            lastName: null,
            email: null,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
        }),
        methods: {
            saveCandidate() {
                var storageRef = storage.ref().child('resume/' + this.email + '/' + this.resumeFile.name);

                storageRef.put(this.resumeFile).then(
                    (snapshot) => {
                        console.log(snapshot)
                    })
                this.dialog = false
                this.alert = true
            },
            uploadResume() {
                this.resumeFile = this.$refs.resumeFile.files[0];
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/career/dialog/NewCandidate.vue